module.exports = __webpack_public_path__ + "img/logo.3cff8547.png";